import { render, staticRenderFns } from "./BannerUpgrade.vue?vue&type=template&id=112d59f2&scoped=true&"
import script from "./BannerUpgrade.vue?vue&type=script&lang=js&"
export * from "./BannerUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./BannerUpgrade.vue?vue&type=style&index=0&id=112d59f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112d59f2",
  null
  
)

export default component.exports